// import React, { useState, useContext, useEffect } from "react";
// import {
//   Breadcrumb,
//   BreadcrumbItem,
//   BreadcrumbLink,
//   BreadcrumbList,
//   BreadcrumbSeparator,
// } from "../ui/breadcrumb";
// import { Card } from "../ui/card";
// import { ChevronsDown, CircleCheck, ShoppingCart } from "lucide-react";
// import { StarFilledIcon } from "@radix-ui/react-icons";
// import { Button } from "../ui/button";
// import img1 from "./../../assets/provider-19.jpg";
// import img2 from "./../../assets/service-47.png";
// import img3 from "./../../assets/service-48.png";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from "../ui/dialog";
// import { Progress } from "../ui/progress";

// import {
//   Carousel,
//   CarouselContent,
//   CarouselItem,
//   CarouselNext,
//   CarouselPrevious,
// } from "../ui/carousel";
// import { Separator } from "../ui/separator";

// import { useLocation, useNavigate } from "react-router-dom";
// import { Toaster } from "../ui/sonner";
// import { toast } from "sonner";
// import { ApiContext } from "src/context/ApiContext.jsx";
// import axios from "axios";

// const ServiceDetail = () => {
//   const token = localStorage.getItem("token");

//   const { subservice, fetchreview, setCheckoutSubServiceId } =
//     useContext(ApiContext);

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const images = [img1, img2, img3, img1, img2];
//   const navigate = useNavigate();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const subserviceId = queryParams.get("subservice");

//   useEffect(() => {
//     setCheckoutSubServiceId(subserviceId);
//   }, [subserviceId]);

//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   }, []);

//   sessionStorage.removeItem("subserviceId");
//   sessionStorage.setItem("subserviceId", subserviceId);

//   // const user = localStorage.getItem("user")
//   const handleThumbnailClick = (index) => {
//     setCurrentIndex(index);
//   };

//   const handlePreviousClick = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex > 0 ? prevIndex - 1 : images.length - 1
//     );
//   };

//   const handleNextClick = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex < images.length - 1 ? prevIndex + 1 : 0
//     );
//   };

//   const filteredSubService = subservice.filter((subservice) => {
//     return subservice._id === subserviceId;
//   });

//   const selectedSubservice = filteredSubService[0];

//   const filteredReviews = fetchreview.filter((review) => {
//     return selectedSubservice?._id === review?.subService?._id;
//   });

//   function calculateReviewStats(reviews) {
//     const totalReviews = reviews.length;
//     const ratingsCount = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
//     let totalRatingSum = 0; // To calculate the average rating

//     // Count occurrences of each rating and sum up ratings
//     reviews.forEach((review) => {
//       if (ratingsCount[review.rating] !== undefined) {
//         ratingsCount[review.rating]++;
//         totalRatingSum += review.rating; // Sum up all ratings
//       }
//     });

//     // Calculate percentages
//     const ratingsPercentage = {};
//     for (let rating in ratingsCount) {
//       ratingsPercentage[rating] =
//         totalReviews > 0
//           ? ((ratingsCount[rating] / totalReviews) * 100).toFixed(2) // Keep 2 decimal places
//           : 0;
//     }

//     // Calculate average rating (out of 5)
//     const averageRating =
//       totalReviews > 0 ? (totalRatingSum / totalReviews).toFixed(2) : "0.00";

//     return {
//       totalReviews,
//       ratingsCount,
//       ratingsPercentage,
//       averageRating,
//     };
//   }

//   const reviews = calculateReviewStats(filteredReviews);

//   const [visibleCount, setVisibleCount] = useState(5); // Initially show 5 reviews

//   const loadMore = () => {
//     setVisibleCount((prevCount) => prevCount + 5); // Show 5 more on each click
//   };

//   const [rating, setRating] = useState(0);
//   const [comment, setComment] = useState("");

//   const handleSubmit = () => {
//     if (!token) {
//       toast.error("Please Login to give a Review");
//       return;
//     }
//     if (!rating) {
//       alert("Please select a rating before submitting!");
//       return;
//     }

//     try {
//       const res = axios.post("https://wavetechservices.in/api/user/reviews", {
//         user: "67bbfc62097a9eeed54ac426",
//         subService: subserviceId,
//         rating: rating,
//         comment: comment,
//       });
//       toast.success("Review added Successfully");
//     } catch (err) {
//       console.error("Error : ", err);
//       toast.error("Error adding Review");
//     }
//   };

//   const handleCheckOut = (subserviceId) => {
//     if (!token) {
//       toast.error("Please Login to Book the service");
//       return;
//     } else {
//       navigate(`/checkout?subservice=${subserviceId}`);
//     }
//   };

//   return (
//     <div className="px-[3vw]">
//       <Toaster />
//       <div className="mt-28 ">
//         <Breadcrumb>
//           <BreadcrumbList>
//             <BreadcrumbItem>
//               <BreadcrumbLink href="/">Home</BreadcrumbLink>
//             </BreadcrumbItem>
//             <BreadcrumbSeparator />
//             <BreadcrumbItem>
//               <BreadcrumbLink href="/search">Service</BreadcrumbLink>
//             </BreadcrumbItem>
//             <BreadcrumbSeparator />
//           </BreadcrumbList>
//         </Breadcrumb>
//       </div>

//       <div className="flex gap-10 my-10 flex-col lg:flex-row">
//         <div className="lg:w-[75%] w-full">
//           <Card className="p-3 ">
//             <div className="flex justify-between items-center ">
//               <h1 className="lg:text-3xl font-bold text-xl">
//                 {selectedSubservice?.name}
//               </h1>
//             </div>
//             <div className="flex items-center gap-2 my-3 text-gray-500">
//               <Button className="bg-green-800 h-6 px-2">
//                 {selectedSubservice?.averageRating}

//                 <StarFilledIcon />
//               </Button>
//               {filteredReviews.length} Reviews
//             </div>

//             <div className="my-5 relative">
//               <Carousel>
//                 <CarouselContent>
//                   {selectedSubservice?.icon?.map((image, index) => (
//                     <CarouselItem
//                       key={index}
//                       className={index === currentIndex ? "block" : "hidden"}
//                     >
//                       <img
//                         src={`${image}`}
//                         alt=""
//                         className="w-full h-[600px] rounded-md object-contain"
//                       />
//                     </CarouselItem>
//                   ))}
//                 </CarouselContent>
//                 <CarouselPrevious
//                   className="absolute left-1"
//                   onClick={handlePreviousClick}
//                 />
//                 <CarouselNext
//                   className="absolute right-1"
//                   onClick={handleNextClick}
//                 />
//               </Carousel>
//             </div>
//             <div className="flex gap-2">
//               {selectedSubservice?.icon?.map((image, index) => (
//                 <img
//                   key={index}
//                   src={`${image}`}
//                   alt=""
//                   className={`w-[19%] rounded-md ${
//                     index === currentIndex ? "border border-blue-500" : ""
//                   }`}
//                   onClick={() => handleThumbnailClick(index)}
//                 />
//               ))}
//             </div>

//             <div>
//               <h1 className="text-2xl mt-5 font-bold mb-2">Service Overview</h1>
//               <p className="text-md text-gray-500">
//                 {selectedSubservice?.description}
//               </p>
//             </div>

//             <div className="my-3">
//               <h1 className="text-2xl ">Includes</h1>
//               <p></p>
//               <div className="bg-gray-50 py-3 p-3 flex flex-wrap gap-4 rounded-md mt-2">
//                 <p className="flex gap-2 items-center text-gray-500">
//                   <CircleCheck className="text-green-700" />
//                   {selectedSubservice?.includes.map((item) => {
//                     return <>{item}</>;
//                   })}
//                 </p>
//               </div>

//               <div className="my-3 rounded-md">
//                 <h1 className="text-2xl ">Excludes</h1>
//                 <p></p>
//                 <div className="bg-gray-50 py-3 p-3 flex flex-wrap gap-4 rounded-md mt-2">
//                   <p className="flex gap-2 items-center text-gray-500">
//                     <CircleCheck className="text-green-700" />
//                     {selectedSubservice?.excludes.map((item) => {
//                       return <>{item}</>;
//                     })}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </Card>

//           <Card className="my-5 rounded-md p-3">
//             <div>
//               <div className="flex justify-between items-center">
//                 <h1 className="text-2xl mt-5 font-bold mb-2">
//                   Reviews ({filteredReviews.length})
//                 </h1>
//                 <Dialog>
//                   <DialogTrigger>
//                     <Button className="h-8 px-2">Write a Review</Button>
//                   </DialogTrigger>
//                   <DialogContent>
//                     <DialogHeader>
//                       <DialogTitle>Write a Review</DialogTitle>
//                       <DialogDescription>
//                         <div className="flex justify-center gap-1 my-3">
//                           {[1, 2, 3, 4, 5].map((star) => (
//                             <StarFilledIcon
//                               key={star}
//                               className={`w-8 h-8 cursor-pointer ${
//                                 star <= rating
//                                   ? "text-yellow-500"
//                                   : "text-gray-400"
//                               }`}
//                               onClick={() => setRating(star)}
//                             />
//                           ))}
//                         </div>

//                         <textarea
//                           cols="30"
//                           rows="5"
//                           placeholder="Write a review"
//                           className="border border-gray-500 w-full my-5 p-2"
//                           value={comment}
//                           onChange={(e) => setComment(e.target.value)}
//                         ></textarea>
//                       </DialogDescription>
//                     </DialogHeader>

//                     <div className="flex justify-center items-center">
//                       <Button
//                         type="submit"
//                         className="px-10 uppercase font-bold"
//                         onClick={handleSubmit}
//                       >
//                         Send
//                       </Button>
//                     </div>
//                   </DialogContent>
//                 </Dialog>
//               </div>
//             </div>

//             <div className="flex gap-4 justify-center items-center w-full">
//               <div className="bg-[#F4F5F5] p-3 space-y-2 rounded-md w-[40%]">
//                 <h1 className="text-2xl text-center">
//                   Customer Reviews & Ratings
//                 </h1>
//                 <div className="flex gap-1 justify-center items-center">
//                   <StarFilledIcon className="text-green-700" />
//                   <StarFilledIcon className="text-green-700" />
//                   <StarFilledIcon className="text-green-700" />
//                   <StarFilledIcon className="text-green-700" />
//                   <StarFilledIcon className="text-green-700" />
//                 </div>
//                 <div className="flex justify-center items-center text-gray-500">
//                   <p>({parseInt(reviews.averageRating)} out of 5)</p>
//                 </div>
//                 <div className="flex justify-center items-center">
//                   <p>Based On {filteredReviews.length} Reviews</p>
//                 </div>
//               </div>
//               <div className="w-[60%]">
//                 {[5, 4, 3, 2, 1].map((rating, ind) => {
//                   return (
//                     <span className="flex items-center gap-2 truncate">
//                       {rating} Star Ratings{" "}
//                       <Progress value={reviews.ratingsPercentage[5 - ind]} />{" "}
//                       {reviews.ratingsCount[5 - ind]}
//                     </span>
//                   );
//                 })}
//               </div>
//             </div>

//             {filteredReviews.slice(0, visibleCount).map((review, index) => (
//               <Card key={index} className="p-3 my-7">
//                 <div>
//                   <div className="flex justify-between items-center">
//                     <div className="flex justify-center items-center gap-2">
//                       <div>
//                         <h1>{review.user?.name}</h1>
//                         <p>
//                           Review on :{" "}
//                           {
//                             new Date(review.createdAt)
//                               .toISOString()
//                               .split("T")[0]
//                           }
//                         </p>
//                       </div>
//                     </div>
//                     <div className="bg-green-700 py-1 p-3 rounded-md text-white">
//                       <span className="flex items-center gap-1">
//                         <StarFilledIcon className="text-white" />{" "}
//                         {review.rating}
//                       </span>
//                     </div>
//                   </div>
//                   <p className="text-sm text-gray-500 my-2">{review.comment}</p>
//                 </div>
//               </Card>
//             ))}

//             {visibleCount < filteredReviews.length && (
//               <div className="flex justify-center items-center">
//                 <Button
//                   onClick={loadMore}
//                   className="flex items-center gap-2 bg-gray-200 text-black font-bold py-1 hover:bg-gray-100"
//                 >
//                   <ChevronsDown /> Load More
//                 </Button>
//               </div>
//             )}
//           </Card>
//         </div>

//         <div className="lg:w-[25%] w-full">
//           <Card className="p-3 sticky top-0 flex flex-col justify-between items-center">
//             <div className="flex justify-between items-center">
//               <div className="p-5 ">
//                 <p className="text-sm text-gray-500">Starts from</p>
//                 <h1 className="text-4xl font-bold flex gap-4 items-center archivo my-3">
//                   <span className="text-black">
//                     ₹
//                     {selectedSubservice?.price && selectedSubservice?.discount
//                       ? (
//                           selectedSubservice.price -
//                           selectedSubservice.price *
//                             (selectedSubservice.discount / 100)
//                         ).toFixed(2)
//                       : selectedSubservice?.price}
//                   </span>
//                   <span className="text-2xl text-gray-400 line-through">
//                     ₹{selectedSubservice?.price}
//                   </span>
//                   <span className="text-sm bg-red-500 text-white px-2 py-1 rounded-lg">
//                     {selectedSubservice?.discount}% OFF
//                   </span>
//                 </h1>
//                 <p className="text-gray-500 text-md flex felx-row gap-3">
//                   <span className="font-semibold">
//                     Taxation and fees (inclusive)
//                   </span>
//                   <p>₹{selectedSubservice?.price * 0.18}</p>
//                 </p>
//               </div>
//             </div>
//             <Separator className="m" />
//             <Button
//               className="gradient w-full text-white font-bold"
//               onClick={() => handleCheckOut(subserviceId)}
//             >
//               <ShoppingCart />
//               Book Now
//             </Button>
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServiceDetail;
import React, { useState, useContext, useEffect } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../ui/breadcrumb";
import { Card } from "../ui/card";
import { ChevronsDown, CircleCheck, ShoppingCart, Star, Sparkles, ChevronRight, ChevronLeft } from "lucide-react";
import { StarFilledIcon } from "@radix-ui/react-icons";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Progress } from "../ui/progress";
import { Separator } from "../ui/separator";
import { useLocation, useNavigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { ApiContext } from "src/context/ApiContext.jsx";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ServiceDetail = () => {
  const token = localStorage.getItem("token");
  const { subservice, fetchreview, setCheckoutSubServiceId } = useContext(ApiContext);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const subserviceId = queryParams.get("subservice");
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [visibleCount, setVisibleCount] = useState(5);
  const user = JSON.parse(localStorage.getItem("user"));
  useEffect(() => {
    setCheckoutSubServiceId(subserviceId);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [subserviceId]);

  const filteredSubService = subservice.filter(s => s._id === subserviceId);
  const selectedSubservice = filteredSubService[0];
  const filteredReviews = fetchreview.filter(r => selectedSubservice?._id === r?.subService?._id);

  function calculateReviewStats(reviews) {
    const totalReviews = reviews.length;
    const ratingsCount = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    let totalRatingSum = 0;

    reviews.forEach((review) => {
      if (ratingsCount[review.rating] !== undefined) {
        ratingsCount[review.rating]++;
        totalRatingSum += review.rating;
      }
    });

    const ratingsPercentage = {};
    for (let rating in ratingsCount) {
      ratingsPercentage[rating] = totalReviews > 0 ? ((ratingsCount[rating] / totalReviews) * 100).toFixed(2) : 0;
    }

    const averageRating = totalReviews > 0 ? (totalRatingSum / totalReviews).toFixed(2) : "0.00";

    return { totalReviews, ratingsCount, ratingsPercentage, averageRating };
  }

  const reviews = calculateReviewStats(filteredReviews);

  const loadMore = () => setVisibleCount(prev => prev + 5);

const handleSubmit = async () => {
  if (!token) {
    toast.error("Please login to give a review");
    return;
  }

  if (!rating) {
    toast.error("Please select a rating before submitting!");
    return;
  }

  try {
    const user = JSON.parse(localStorage.getItem("user")); // Make sure user is available

    if (!user?.userId) {
      toast.error("User not found. Please login again.");
      return;
    }

    const res = await axios.post("https://wavetechservices.in/api/user/reviews", {
      user: user.userId,
      subService: subserviceId,
      rating,
      comment,
    });

    console.log("Review submitted successfully:", res.data);
    toast.success("Review added successfully");
  } catch (err) {
    console.error("Error:", err);
    const errorMessage =
      err?.response?.data?.message || "Error adding review. Please try again.";
    toast.error(errorMessage);
  }
};


  const handleCheckOut = (subserviceId) => {
    if (!token) {
      toast.error("Please Login to Book the service");
      return;
    }
    sessionStorage.setItem("subservice", subserviceId);
    navigate(`/checkout?subservice=${subserviceId}`);
  };

  // Calculate discounted price
  const discountedPrice = selectedSubservice?.price && selectedSubservice?.discount
    ? (selectedSubservice.price - selectedSubservice.price * (selectedSubservice.discount / 100)).toFixed(2)
    : selectedSubservice?.price;

  // Calculate tax (18%)
  const taxAmount = (discountedPrice * 0.18).toFixed(2);
  console.log("selectedSubservice : " , selectedSubservice)
  return (
    <div className="px-[3vw] min-h-screen bg-gradient-to-b from-gray-100 to-white">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(8)].map((_, i) => (
          <motion.div
            key={i}
            animate={{
              x: [0, 100 * (i % 2 === 0 ? 1 : -1)],
              y: [0, 50 * (i % 3 === 0 ? 1 : -1)],
              rotate: [0, 360],
              opacity: [0.05, 0.15, 0.05]
            }}
            transition={{
              duration: 30 + i * 5,
              repeat: Infinity,
              ease: "linear"
            }}
            className="absolute rounded-full bg-gradient-to-r from-blue-100/50 to-purple-100/50"
            style={{
              width: `${150 + i * 30}px`,
              height: `${150 + i * 30}px`,
              top: `${10 + i * 10}%`,
              left: `${10 + (i * 12) % 80}%`,
              filter: "blur(60px)"
            }}
          />
        ))}
      </div>

      <div className="relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="pt-28"
        >
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/" className="hover:text-primary transition-colors">
                  Home
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-gray-400" />
              <BreadcrumbItem>
                <BreadcrumbLink href="/search" className="hover:text-primary transition-colors">
                  Services
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-gray-400" />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium text-primary">
                  {selectedSubservice?.name}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </motion.div>

        <div className="flex gap-10 my-10 flex-col lg:flex-row">
          {/* Main Content */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
            className="lg:w-[75%] w-full"
          >
            <Card className="p-6 border border-gray-200/50 bg-white/80 backdrop-blur-sm shadow-xl rounded-xl">
              <motion.div 
                whileHover={{ scale: 1.01 }}
                className="flex justify-between items-center mb-6"
              >
                <h1 className="text-3xl md:text-4xl font-bold text-gradient bg-clip-text text-transparent">
                  {selectedSubservice?.name}
                </h1>
                <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full shadow-sm border border-gray-200">
                  <StarFilledIcon className="text-yellow-500 w-5 h-5" />
                  <span className="font-medium">{selectedSubservice?.averageRating || "4.5"}</span>
                  <span className="text-sm text-gray-500">({filteredReviews.length})</span>
                </div>
              </motion.div>

              {/* Premium Image Slider */}
              <div className="relative my-6 rounded-xl overflow-hidden">
                <Swiper
                  modules={[Navigation, Pagination, Thumbs]}
                  navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  }}
                  pagination={{ clickable: true }}
                  thumbs={{ swiper: thumbsSwiper }}
                  spaceBetween={10}
                  slidesPerView={1}
                  className="rounded-xl shadow-lg"
                >
                  {selectedSubservice?.icon?.map((image, index) => (
                    <SwiperSlide key={index}>
                      <motion.div
                        whileHover={{ scale: 1.02 }}
                        className="relative aspect-video overflow-hidden"
                      >
                        <img
                          src={image}
                          alt={`Service ${index + 1}`}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.src = "https://via.placeholder.com/800x450";
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                      </motion.div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                
                {/* Custom Navigation Arrows */}
                <button className="swiper-button-prev absolute left-4 top-1/2 z-10 -translate-y-1/2 w-10 h-10  rounded-full  flex items-center justify-center  transition-all">
                  {/* <ChevronLeft className="w-6 h-6 text-gray-800" /> */}
                </button>
                <button className="swiper-button-next absolute right-4 top-1/2 z-10 -translate-y-1/2 w-10 h-10  rounded-full  flex items-center justify-center  transition-all">
                  {/* <ChevronRight className="w-6 h-6 text-gray-800" /> */}
                </button>
              </div>

              {/* Thumbnail Slider */}
              {selectedSubservice?.icon?.length > 1 && (
                <div className="mt-4">
                  <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={5}
                    freeMode={true}
                    watchSlidesProgress={true}
                    className="thumbnail-slider"
                  >
                    {selectedSubservice?.icon?.map((image, index) => (
                      <SwiperSlide key={index} className="cursor-pointer">
                        <motion.div
                          whileHover={{ scale: 1.05 }}
                          className="relative aspect-square overflow-hidden rounded-lg border-2 border-transparent hover:border-primary transition-all"
                        >
                          <img
                            src={image}
                            alt={`Thumbnail ${index + 1}`}
                            className="w-full h-full object-cover"
                          />
                        </motion.div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              )}

              {/* Service Overview */}
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="mt-8"
              >
                <h1 className="text-2xl md:text-3xl font-bold mb-4 text-gradient bg-clip-text">
                  Service Overview
                </h1>
                <p className="text-gray-600 leading-relaxed">
                  {selectedSubservice?.description}
                </p>
              </motion.div>

              {/* Includes & Excludes */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <motion.div 
                  whileHover={{ y: -5 }}
                  className="bg-gradient-to-br from-blue-50 to-purple-50 p-5 rounded-xl border border-blue-100"
                >
                  <h2 className="text-xl font-bold mb-3 text-blue-700">Includes</h2>
                  <ul className="space-y-2">
                    {selectedSubservice?.includes?.map((item, index) => (
                      <motion.li 
                        key={index}
                        whileHover={{ x: 5 }}
                        className="flex items-center gap-2 text-gray-700"
                      >
                        <CircleCheck className="text-green-600 min-w-5" />
                        <span>{item}</span>
                      </motion.li>
                    ))}
                  </ul>
                </motion.div>

                <motion.div 
                  whileHover={{ y: -5 }}
                  className="bg-gradient-to-br from-red-50 to-pink-50 p-5 rounded-xl border border-red-100"
                >
                  <h2 className="text-xl font-bold mb-3 text-red-700">Excludes</h2>
                  <ul className="space-y-2">
                    {selectedSubservice?.excludes?.map((item, index) => (
                      <motion.li 
                        key={index}
                        whileHover={{ x: 5 }}
                        className="flex items-center gap-2 text-gray-700"
                      >
                        <CircleCheck className="text-red-600 min-w-5" />
                        <span>{item}</span>
                      </motion.li>
                    ))}
                  </ul>
                </motion.div>
              </div>
            </Card>

            {/* Reviews Section */}
            <Card className="my-8 p-6 border border-gray-200/50 bg-white/80 backdrop-blur-sm shadow-xl rounded-xl">
              <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  Customer Reviews ({filteredReviews.length})
                </h1>
                
                <Dialog>
                  <DialogTrigger asChild>
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className="px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg shadow-md hover:shadow-lg transition-all"
                    >
                      Write a Review
                    </motion.button>
                  </DialogTrigger>
                  <DialogContent className="max-w-md rounded-xl border-0 bg-white/90 backdrop-blur-sm shadow-2xl">
                    <DialogHeader>
                      <DialogTitle className="text-2xl font-bold text-center bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                        Share Your Experience
                      </DialogTitle>
                      <DialogDescription>
                        <motion.div 
                          className="flex justify-center gap-1 my-6"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ delay: 0.2 }}
                        >
                          {[1, 2, 3, 4, 5].map((star) => (
                            <motion.div
                              key={star}
                              whileHover={{ scale: 1.2 }}
                              whileTap={{ scale: 0.9 }}
                            >
                              <StarFilledIcon
                                className={`w-10 h-10 cursor-pointer transition-colors ${
                                  star <= rating ? "text-yellow-500" : "text-gray-300"
                                }`}
                                onClick={() => setRating(star)}
                              />
                            </motion.div>
                          ))}
                        </motion.div>

                        <motion.textarea
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.3 }}
                          placeholder="Tell us about your experience..."
                          className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none transition-all min-h-[150px]"
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      </DialogDescription>
                    </DialogHeader>

                    <motion.div 
                      className="flex justify-center"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.4 }}
                    >
                      <Button
                        onClick={handleSubmit}
                        className="px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg shadow-lg hover:shadow-xl transition-all"
                      >
                        Submit Review
                      </Button>
                    </motion.div>
                  </DialogContent>
                </Dialog>
              </div>

              {/* Rating Summary */}
              <div className="flex flex-col md:flex-row gap-6 mb-10">
                <motion.div 
                  whileHover={{ scale: 1.02 }}
                  className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl w-full md:w-[40%] text-center border border-blue-100"
                >
                  <h2 className="text-4xl font-bold mb-2">{reviews.averageRating}</h2>
                  <div className="flex justify-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <StarFilledIcon 
                        key={i} 
                        className={`w-5 h-5 ${i < Math.floor(reviews.averageRating) ? 'text-yellow-500' : 'text-gray-300'}`}
                      />
                    ))}
                  </div>
                  <p className="text-gray-600">Based on {filteredReviews.length} reviews</p>
                </motion.div>

                <div className="w-full md:w-[60%] space-y-3">
                  {[5, 4, 3, 2, 1].map((rating) => (
                    <motion.div 
                      key={rating}
                      whileHover={{ x: 5 }}
                      className="flex items-center gap-3"
                    >
                      <span className="w-16 font-medium">{rating} Star</span>
                      <Progress 
                        value={reviews.ratingsPercentage[rating]} 
                        className="h-2 flex-1 bg-gray-200"
                        indicatorClassName="bg-gradient-to-r from-blue-500 to-purple-500"
                      />
                      <span className="w-10 text-right text-gray-600">
                        {reviews.ratingsCount[rating]}
                      </span>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Reviews List */}
              <AnimatePresence>
                {filteredReviews.slice(0, visibleCount).map((review, index) => (
                  <motion.div
                    key={review._id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="mb-6"
                  >
                    <Card className="p-5 border border-gray-200/50 hover:border-primary/30 transition-all">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h3 className="font-bold text-lg">{review.user?.name}</h3>
                          <p className="text-sm text-gray-500">
                            {new Date(review.createdAt).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })}
                          </p>
                        </div>
                        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 py-1 rounded-full flex items-center gap-1">
                          <StarFilledIcon className="w-4 h-4" />
                          <span className="font-medium">{review.rating}</span>
                        </div>
                      </div>
                      <p className="text-gray-700">{review.comment}</p>
                    </Card>
                  </motion.div>
                ))}
              </AnimatePresence>

              {visibleCount < filteredReviews.length && (
                <div className="flex justify-center mt-6">
                  <motion.button
                    onClick={loadMore}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg shadow-lg hover:shadow-xl transition-all flex items-center gap-2"
                  >
                    <ChevronsDown /> Load More Reviews
                  </motion.button>
                </div>
              )}
            </Card>
          </motion.div>

          {/* Booking Card */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="lg:w-[25%] w-full"
          >
            <Card className="p-6 sticky top-6 border border-gray-200/50 bg-white/90 backdrop-blur-sm shadow-xl rounded-xl">
              <motion.div 
                whileHover={{ scale: 1.01 }}
                className="mb-6"
              >
                <h2 className="text-sm text-gray-500 mb-1">Starts from</h2>
                <div className="flex items-end gap-2">
                  <h1 className="text-4xl font-bold text-gray-900">
                    ₹{discountedPrice}
                  </h1>
                  <span className="text-lg text-gray-400 line-through">
                    ₹{selectedSubservice?.price}
                  </span>
                  <span className="text-sm bg-gradient-to-r from-red-500 to-pink-500 text-white px-2 py-1 rounded-lg">
                    {selectedSubservice?.discount}% OFF
                  </span>
                </div>
                <div className="mt-3 text-sm text-gray-600">
                  <p className="flex justify-between">
                    <span>Taxes (18%)</span>
                    <span>₹{taxAmount}</span>
                  </p>
                </div>
              </motion.div>

              <Separator className="my-4 bg-gray-200" />

              <motion.div 
                whileHover={{ scale: 1.02 }}
                className="mt-6"
              >
                <Button
                  onClick={() => handleCheckOut(subserviceId)}
                  className="w-full py-6 gradient text-white rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2"
                >
                  <ShoppingCart className="w-5 h-5" />
                  <span className="text-lg font-bold">Book Now</span>
                </Button>
              </motion.div>

              {/* Floating particles */}
              <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-0 hover:opacity-100 transition-opacity duration-300">
                {[...Array(8)].map((_, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0 }}
                    animate={{
                      opacity: [0, 0.8, 0],
                      y: [0, -20, 0],
                      x: [0, Math.random() * 40 - 20, 0]
                    }}
                    transition={{
                      duration: 3 + Math.random() * 4,
                      repeat: Infinity,
                      delay: i * 0.3
                    }}
                    className="absolute text-yellow-400 text-xl"
                    style={{
                      left: `${Math.random() * 100}%`,
                      top: `${Math.random() * 100}%`
                    }}
                  >
                    {["✧", "✦", "❂", "✺", "✶"][i % 5]}
                  </motion.div>
                ))}
              </div>
            </Card>
          </motion.div>
        </div>
      </div>
      {/* <Toaster richColors position="top-center" /> */}
    </div>
  );
};

export default ServiceDetail;